import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Items from './internal/items';
var Rows = /*#__PURE__*/function (_Component) {
  _inherits(Rows, _Component);
  var _super = _createSuper(Rows);
  function Rows() {
    _classCallCheck(this, Rows);
    return _super.apply(this, arguments);
  }
  _createClass(Rows, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        items = _this$props.items,
        render = _this$props.render,
        _this$props$loadingLa = _this$props.loadingLabel,
        loadingLabel = _this$props$loadingLa === void 0 ? 'Loading' : _this$props$loadingLa;
      return /*#__PURE__*/React.createElement("div", {
        role: "rowgroup"
      }, /*#__PURE__*/React.createElement(Items, {
        items: items,
        loadingLabel: loadingLabel,
        render: render
      }));
    }
  }]);
  return Rows;
}(Component);
export { Rows as default };